import { UserSquare } from "@mynaui/icons-react";
import Icon from '@mdi/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenFancy } from '@fortawesome/free-solid-svg-icons';
import { mdiChartBoxOutline } from '@mdi/js';
import {CalendarMention20Regular , Payment20Regular} from '@fluentui/react-icons';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import { AiOutlineFileDone } from "react-icons/ai";
import { MdOutlinePendingActions } from "react-icons/md";
import { BiHomeAlt } from "react-icons/bi";
import { FiCalendar, FiUser } from "react-icons/fi";
import { MdTimer } from "react-icons/md";
import { HiMiniHandRaised } from "react-icons/hi2";
import { Contact02Icon } from 'hugeicons-react';
import { IoMdInformationCircleOutline } from "react-icons/io";
import {ReactComponent as Pay } from "../assets/Sidebar/Pay.svg"
import { LuCalendarClock } from "react-icons/lu";


export const sideBarOptions = [
    {
        title: "Dashboard",
        icon: <BiHomeAlt style={{ width: "20px", height: "20px" }} />,
        link: "/"
        
    },
    {
        title: "Order Now",
        icon: <CalculateOutlinedIcon style={{ width: "20px", height: "20px" }} />,
        link: "/calculation"
        
    },
    // {
    //     title: "My Wallet",
    //     icon: <Pay style={{ width: "20px", height: "20px" }} />,
    //     link: "/my-wallet",
    // },    
    // {
    //     title: "Profile",
    //     icon: <FiUser style={{ width: "20px", height: "20px" }} />,
    //     link: "/edit-profile"
    // },   
    {
        title: "My Orders",
        icon: <FiCalendar style={{ width: "20px", height: "20px" }} />,
        link: "/my-orders",
    },
    {
        title: "Pending Orders",
        icon: <LuCalendarClock style={{ width: "20px", height: "20px" }} />,
        link: "/pending-orders"
    },
    {
        title: "In Progress",
        icon: <MdOutlinePendingActions style={{ width: "20px", height: "20px" }} />,
        link: "/in-progress"
    },
    {
        title: "Completed Orders",
        icon: <AiOutlineFileDone style={{ width: "20px", height: "20px" }} />,
        link: "/raise-complaint",
    },  
    // {
    //     title: "About Us",
    //     icon: <IoMdInformationCircleOutline style={{ width: "20px", height: "20px" }} />,
    //     link: "/about-us",
    // },
    // {
    //     title: "Contact Us",
    //     icon: <Contact02Icon style={{ width: "20px", height: "20px" }} />,
    //     link: "/contact-us"
    // },
    {
        title: "My Wallet",
        icon: <Pay style={{ width: "20px", height: "20px" }} />,
        link: "/my-wallet",
    },    
    {
        title: "Profile",
        icon: <FiUser style={{ width: "20px", height: "20px" }} />,
        link: "/edit-profile"
    },   
    {
        title: "Terms And Condition",
        icon: <IoMdInformationCircleOutline style={{ width: "20px", height: "20px" }} />,
        link: "/terms-and-conditions"
    },
];